import React from 'react';
import Reward from './Reward.jsx';
import ResetButton from './ResetButton.jsx';
import { version } from '../package.json';
const idleRewards = require('./files/StageIdle.json').ed.StageIdleTable;
const stages = require('./files/Stage.json').ed.StageTable;
const Items = require('./files/Item.json').ed.ItemTable;

const SAVE_KEY='afk-timers';

const Chests = {
  17: "Hero's Essence",
  18: 'Crude Gear',
  19: 'Common Gear',
  20: 'Rare Gear',
  21: 'Rare+ Gear',
  22: 'Elite Gear',
  23: 'Elite+ Gear',
  24: 'Legendary Gear',
  25: 'Legendary+ Gear',
  26: 'Mythic Gear',
  84: 'Invigorating Essence',
  114: 'Dura Shards',
  135: 'Primordial Emblem',
  136: 'Amplifying Emblem',
  137: 'Factional Emblem',
  131: 'Mythic T1 Stone',
  170: 'Mythic T2 Stone',
  171: 'Mythic T2 (Future T3?) Stone',
  172: 'Mythic T2 (Future T4?) Stone',
  173: 'Twisted Essence'
}

const parseReward = reward => {
  const type = reward[0];
  const id = reward[1];
  const quantity = reward[2];
  switch(type.toLowerCase()){
    case 'currency':
          return [id, quantity].join(' x ');
      case 'item':
          return [Items[id].Name, quantity].join(' x ');
      case 'chest':
          return [Chests[id], quantity].join(' x ');
      default:
          return [`${type}: ${id}`, quantity].join(' x ');
  }
}

const stageMap = {};



Object.values(stages).forEach(stage => {
  // console.log(stage);
  const { MappiontID, ChapterID, StageName, IdleID } = stage;
  if(!stageMap[ChapterID]) stageMap[ChapterID] = {};
  stageMap[ChapterID][MappiontID] = {
    ...idleRewards[IdleID],
    StageName
  };
});

const getRewardsForStage = (chapter, stage) => {
  const config = stageMap[chapter][stage];
  const { NewRewards, NewRewardCDs } = config;
  const rewards = [

  ];
  for(let i = 0;  i < NewRewardCDs.length; i++ ){
    rewards.push({
      content: parseReward(NewRewards.slice(i*3, i*3+3)),
      timer: NewRewardCDs[i]
    });
  }
  return rewards;
}

export default class Base extends React.Component {
  constructor(props){
    super(props);
    if(localStorage.getItem(SAVE_KEY)){
      this.state=JSON.parse(localStorage.getItem(SAVE_KEY));
    }else{
      this.state = {
        accounts: {
          0: this.newAccount(),
        },
        currentAccount: 0,
      }
    }
  }

  newAccount = () => {
    const timer = Date.now();
    const rewardTimers = {};
    stageMap[1][1]
      .NewRewardCDs
      .forEach((_cd, i) => rewardTimers[i]=timer);
      return {
        chapter: 1,
        stage: 1,
        timer,
        rewardTimers
      }
  }

  componentDidMount(){
    this.interval = setInterval(()=>requestAnimationFrame(this.updateTimer), 1000);
  }
  
  updateChapter = ({ target: { value: chapter } }) => {
    chapter = parseInt(chapter, 10);
    if(chapter > 34) chapter = 34;
    const currentAccount = this.getCurrentAccount();
    const rewardTimers = {};
    stageMap[chapter][1]
      .NewRewardCDs
      .forEach((_cd, i) => rewardTimers[i]=currentAccount.timer);
      const account = {
        ...currentAccount,
        chapter,
        stage: 1,
        rewardTimers,
      }
      this.setAccountState(account);
  }

  resetAll = (delay=0) => {
    const currentAccount = this.getCurrentAccount();
    const rewardTimers = {};
    stageMap[currentAccount.chapter][currentAccount.stage]
      .NewRewardCDs
      .forEach((_cd, i) => rewardTimers[i]=currentAccount.timer - delay);
    const account = {
      ...currentAccount,
      rewardTimers,
    }
    console.log({
      currentAccount,
      account
    })
    this.setAccountState(account);
  }
  advanceProgress = () => {
    const currentAccount = this.getCurrentAccount();
    if(currentAccount.chapter === 34 && currentAccount.stage === 60 ) return;
    let nextChapter = currentAccount.chapter;
    let nextStage = currentAccount.stage + 1;
    if(nextStage >= Object.values(stageMap[nextChapter]).length){
      nextStage = 1;
      nextChapter+=1;
    }
    const rewardTimers = {};
    stageMap[nextChapter][nextStage]
      .NewRewardCDs
      .forEach((_cd, i) => rewardTimers[i]=currentAccount.timer);

      const account = {
        ...this.getCurrentAccount(),
        chapter: nextChapter,
        stage: nextStage,
        rewardTimers,
      }
      this.setAccountState(account);
  }
  addAccount = () => {
    const nextAccount = Object.keys(this.state.accounts).length;
    const account = this.newAccount();
    this.setState({
      accounts: {
        ...this.state.accounts,
        [nextAccount]:account
      },
      currentAccount: nextAccount
    });
  }
  getCurrentAccount = () => this.state.accounts[this.state.currentAccount];
  setAccountState = newState => this.setState(({accounts, currentAccount}) => ({
    accounts: {
      ...accounts,
      [currentAccount] : newState
    }
  }))
  updateStage = ({ target: { value: stage } }) => {
    const currentAccount = this.getCurrentAccount();
    stage = parseInt(stage, 10);
    const rewardTimers = {};
    stageMap[currentAccount.chapter][stage]
      .NewRewardCDs
      .forEach((_cd, i) => rewardTimers[i]=currentAccount.timer);
    const account = {
      ...currentAccount,
      stage,
      rewardTimers,
    }
    this.setAccountState(account);
  }
  updateRewardTimer = i => (delay=0) => {
    const currentAccount = this.getCurrentAccount();
    const { rewardTimers, timer } = currentAccount;
    rewardTimers[i] = timer-delay;
    this.setAccountState({
      ...currentAccount,
      rewardTimers
    })
  }

  updateTimer = () => {
    const timer = Date.now();
    const currentAccount = this.getCurrentAccount();
    this.setAccountState({
      ...currentAccount,
      timer
    });
  };
  componentWillUnmount(){
    clearInterval(this.interval);
  }
  save = () => {
    localStorage.setItem(SAVE_KEY, JSON.stringify(this.state));
  }
  updateCurrentAccount = ({ target: { value : currentAccount }}) => this.setState({
    currentAccount: parseInt(currentAccount, 10),
  });


  render(){
    const { accounts, currentAccount } = this.state;
    const { updateChapter, updateStage, save, resetAll, advanceProgress, updateCurrentAccount, addAccount, updateRewardTimer } = this;
    const { chapter, stage, rewardTimers, timer } = accounts[currentAccount];

    return (
      <div id="calculator">
        <div id="top-controls">   
          <div id="account-select">
            Account:
            <select id="account" value={currentAccount} onChange={updateCurrentAccount}>
              {Object.keys(accounts).map(accountId => <option key={`account-${accountId}`} value={accountId}>{(parseInt(accountId) + 1)}</option>)}
            </select>
            <button onClick={addAccount}>Add Account</button>
          </div>
          <div id="chapter-select">
            Chapter:
            <select id="chapter" value={chapter} onChange={updateChapter}>
              {Object.keys(stageMap).map(chapterNumber => chapterNumber < 35 && <option key={chapterNumber} value={chapterNumber}>{chapterNumber}</option>)}
            </select>
            Stage:
            <select id="stage" value={stage} onChange={updateStage}>
              {Object.keys(stageMap[chapter]).map(stageNumber => <option key={stageNumber} value={stageNumber}>{stageNumber}</option>)}
            </select>
          </div>
          <div id="main-controls">
            <button onClick={save}>Save</button>
            <button onClick={advanceProgress}>Advance Stage</button>
          </div>
        </div>
        <div id="reward-pane">
          <ResetButton reset={resetAll} text='Reset All'/>
          <div id="rewards">
            {(getRewardsForStage(chapter, stage)).map((reward, i) => (
            <Reward
              key={`${chapter}-${stage}-${i}`}
              reward={reward}
              globalTimer={timer}
              timer={rewardTimers[i]}
              updateParent={updateRewardTimer(i)} />
            ))}
          </div>
        </div>
        <div id="footer">
          <span>♥ Created by ☆Skye☆ ♥</span>
          <span>Special thanks to Panafonic</span>
          <span>v{version}</span>
        </div>
      </div>
    );
  }
};
